import { forwardRef, type Ref, type SVGProps } from "react";
const IconHeatingFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M21 18.11V7a5 5 0 0 0-10 0v11.11a7 7 0 1 0 10 0M16 26a3 3 0 0 1-1-5.82V8a1 1 0 0 1 2 0v12.18A3 3 0 0 1 16 26"
    />
  </svg>
);
const ForwardRef = forwardRef(IconHeatingFilledSVG);
ForwardRef.displayName = "IconHeatingFilled";
export { ForwardRef as IconHeatingFilled };
